import React, { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Routes } from '../../enums';
import { ChevronRightTwoTone, HomeTwoTone } from '../../icons';
import styles from './breadcrumbs.module.css';

export const Breadcrumbs: React.FC = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const { pathname } = useLocation();

  const path = pathname.replace(publicUrl, '').replace(/^\/|\/$/g, ''); // remove first and last slash
  const pathArr = path ? path.split('/') : [];

  const breadcrumbs: { path: string; name: string; icon: JSX.Element | null }[] = pathArr.map((element, index) => {
    const chain = pathArr.filter((entity, entityIndex) => entityIndex <= index).join('/');
    return {
      icon: null,
      path: `${publicUrl}/${chain}`,
      name: element
        .split('-')
        .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
        .join(' '),
    };
  });

  breadcrumbs.unshift({ path: Routes.Reports, name: 'Home', icon: <HomeTwoTone fontSize="inherit" /> });

  return (
    <div className={`${styles.root}`}>
      {breadcrumbs.map((breadcrumb, index) => (
        <Fragment key={breadcrumb.path}>
          {index > 0 && index < breadcrumbs.length && (
            <div className={styles.divider}>
              <ChevronRightTwoTone fontSize="small" />
            </div>
          )}
          <Link className={styles.segment} to={breadcrumb.path}>
            {breadcrumb.icon && <span className={styles.icon}>{breadcrumb.icon}</span>}
            {breadcrumb.name}
          </Link>
        </Fragment>
      ))}
    </div>
  );
};
